import { BetQLSportItem } from "@rotoql/common-services";
import React from "react";
import TeamLogo from "src/components/Team/TeamLogo";
import { capitalize } from "src/services/DisplayService";
import { TrendsPickType } from "src/services/EventService";
import { UpgradeToView } from "../../RowComponents";

interface TrendCellOptions {
  selectedTeam: TrendsPickType;
  game: any;
  periodFilter: string;
  index: number;
  currentSportObj: BetQLSportItem;
  showDraw: boolean;
  hasAccess: boolean;
}

const getPrefix = ({ selectedTeam, isTotalBet }: { selectedTeam: "away" | "home" | "draw"; isTotalBet: boolean }) => {
  let prefix = "";

  if (selectedTeam === "draw" || !isTotalBet) {
    return prefix;
  }

  if (selectedTeam === "home") {
    prefix = "U ";
  }

  if (selectedTeam === "away") {
    prefix = "O ";
  }

  return prefix;
};

export const getTrendCell = ({
  selectedTeam,
  game,
  periodFilter,
  index,
  currentSportObj,
  showDraw,
  hasAccess,
}: TrendCellOptions) => {
  const classname: string = "games-table-column__trend-cell";
  const classNameForDraw = showDraw ? `${classname}--draw` : "";

  if (!hasAccess) {
    return (
      <UpgradeToView
        key={index}
        className={`${classname} ${classNameForDraw} ${classname}--paywall`}
        showText={true}
        isSharpStat={false}
        trackingProps={{
          screen: "FeedView",
          page: "Games Table",
          source: "Trend Cell",
          sport: currentSportObj.key,
          gameId: game.id,
          awayTeam: game.awayTeam.fullName,
          homeTeam: game.homeTeam.fullName,
        }}
      />
    );
  }

  if (!selectedTeam || selectedTeam === "draw") {
    const displayText = !selectedTeam ? "No Pick" : "Draw";
    return (
      <div key={index} className={`${classname} ${classNameForDraw}`}>
        <div className="games-table-column__text-container">
          <p className="games-table-column__line-text--bold">{displayText}</p>
        </div>
      </div>
    );
  }

  const team = game[`${selectedTeam}Team`];
  const line = game[`current${periodFilter}${capitalize(selectedTeam)}Display`];
  const isTotalBet = periodFilter.includes("total");

  return (
    <div key={index} className={`${classname} ${classNameForDraw}`}>
      {!isTotalBet ? (
        <>
          <TeamLogo
            leagueName={currentSportObj.imagePath}
            teamAbbreviation={currentSportObj.isTennis ? team.country : team.preferredAbbreviation}
            size={35}
          />
          <div className="games-table-column__team-info-container">
            <p className="games-table-column__team-name games-table-column__team-name--bold">
              {currentSportObj.isCollege ? team.fullName : team.lastName}
            </p>
          </div>
        </>
      ) : null}

      <div className="games-table-column__text-container">
        <p className="games-table-column__line-text">
          {getPrefix({ selectedTeam, isTotalBet })}
          {line}
        </p>
      </div>
    </div>
  );
};
